import { render, staticRenderFns } from "./PaymentElement.vue?vue&type=template&id=25b5f60c&"
import script from "./PaymentElement.vue?vue&type=script&lang=js&"
export * from "./PaymentElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports